// extracted by mini-css-extract-plugin
export default {"wrapper":"formTextArea_wrapper__wVV9y","inputBox":"formTextArea_inputBox__hZM9l","input":"formTextArea_input__dvpo0","floatingLabel":"formTextArea_floatingLabel__SIR5V"};